import React from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container } from 'react-bootstrap'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomForm from '../Components/CustomForm/CustomForm'
import { addRestaurant } from '../hooks/resturant'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

function AddResturants() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
      const infoData = [
    {
      id: 0,
      title: "معلومات أساسية",
      inputs: [
        { id: "name", title: "الاسم", type: "text" },
      ],
    },
  ];

  const handleSubmit = (formData) => {
    
    // formData will usually be an object like { name: "Restaurant Name" }
    dispatch(addRestaurant(formData))
      .unwrap() // Allows us to use .then() / .catch() on the thunk result
      .then(() => {
        alert("تم إضافة المطعم بنجاح");
        navigate('/dashboard/resturants'); // Redirect to list page
      })
      .catch((err) => {
        // Error is already handled in Redux, but you can do specific UI logic here
        console.error("Failed to save:", err);
      });
  };
  return (
    <div>
        <AuthNavbar/>
          <Container>
                    <CustomHeader
          title={"إضافة مطعم جديد"}
          subtitle={""}
          downloadData={false}
        />
        <CustomForm
formStructure={infoData}
image={false}
onSubmit={handleSubmit}
        />
            </Container>
            </div>
  )
}

export default AddResturants
